import { render } from "./ContactFaq.vue?vue&type=template&id=1e2b695e&ts=true"
import script from "./ContactFaq.vue?vue&type=script&lang=ts"
export * from "./ContactFaq.vue?vue&type=script&lang=ts"

import "./ContactFaq.vue?vue&type=style&index=0&id=1e2b695e&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__